/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_CustomerInputs */

const en_account_customer = /** @type {(inputs: Account_CustomerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customer`)
};

/**
* | output |
* | --- |
* | "Customer" |
*
* @param {Account_CustomerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const account_customer = /** @type {((inputs?: Account_CustomerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_CustomerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_account_customer(inputs)
});